import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";

import { customTooltipHandlerFull, formatNumber } from "..";
import styles from "../statistics.module.css";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

export function Average3DaysMarketCap({ avgMarketCapMonthAgo }) {
  const labels = ["Above $500M", "$100M to $500M", "Below $100M"];
  const dataValues = [
    avgMarketCapMonthAgo?.above_500m.percent,
    avgMarketCapMonthAgo?.between_100m_500m.percent,
    avgMarketCapMonthAgo?.below_100m.percent,
  ];
  const valueValues = [
    avgMarketCapMonthAgo?.above_500m.value,
    avgMarketCapMonthAgo?.between_100m_500m.value,
    avgMarketCapMonthAgo?.below_100m.value,
  ];
  const barColors = ["#236192", "#418FDE", "#34B3F1"];

  const data = {
    labels,
    datasets: [
      {
        label: "Market Cap Distribution",
        data: dataValues,
        backgroundColor: barColors,
        borderRadius: 6,
        barPercentage: 0.4,
        categoryPercentage: 0.6,
      },
    ],
  };

  const options = {
    indexAxis: "y",
    responsive: true,
    maintainAspectRatio: false,
    layout: { padding: { top: 0, bottom: 0 } },
    plugins: {
      legend: { display: false },
      tooltip: {
        enabled: false,
        external: (context) => {
          const index = context.tooltip?.dataPoints?.[0]?.dataIndex;
          if (index === undefined) return;

          const rawValue = Math.round(valueValues[index]);
          const percentValue = dataValues[index].toFixed(0);

          const formattedValue = formatNumber(rawValue);
          customTooltipHandlerFull(context, formattedValue, percentValue);
        },
      },
    },
    scales: {
      x: {
        beginAtZero: true,
        max: 100,
        ticks: {
          stepSize: 25,
          callback: (value) => `${value}`,
        },
        grid: { color: "rgba(200,200,200,0.1)" },
      },
      y: {
        grid: { color: "rgba(200,200,200,0.1)" },
      },
    },
  };

  return (
    <div className={styles.statisticsContent}>
      <h2 className={styles.statisticsTitle}>Average 30 Days Market Cap</h2>
      <div className={styles.statisticsColoredBar}>
        <div
          className={styles.statisticTableWrapper}
          style={{ marginTop: "10px", height: "180px" }}
        >
          <div
            className={styles.statisticTableOneColumn}
            style={{ marginTop: "10px", height: "240px" }}
          >
            <Bar options={options} data={data} />
          </div>
        </div>
      </div>
    </div>
  );
}
